<template>
    <div class="component-content">
        <section class="content">
            <el-card class="box-card">
                <el-dialog
                    title="信息更新结果"
                    :visible.sync="resultShow"
                    width="60%" lock-scroll
                    center>
                    <el-table :data="resultArray"
                              row-key="id + '_' + server_url"
                              stripe
                              style="width: 100%;"
                              :default-sort="{prop: 'id'}"
                    >
                        <el-table-column prop="serverName" label="服务器名" width="180">
                        </el-table-column>
                        <el-table-column prop="serverNumber" label="编号" width="100">
                        </el-table-column>
                        <el-table-column prop="type" label="类型" width="100">
                        </el-table-column>
                        <el-table-column prop="resStatus" label="响应码" width="100">
                        </el-table-column>
                        <el-table-column prop="resMsg" label="响应消息" width="100">
                        </el-table-column>
                        <el-table-column prop="serverUrl" label="重载请求地址" width="350">
                        </el-table-column>

                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="resultShow = false">关闭</el-button>
                    </div>
                </el-dialog>

                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="战区" name="login_info_world">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>机器信息</span>

                                <el-button type="text" @click="worldMaintenanceShow()">
                                    一键维护
                                </el-button>
                            </div>
                            <el-table :data="loginInfoWorld"
                                      row-key="id"
                                      border
                                      style="width: 100%;"
                                      :default-sort="{prop: 'id'}"
                                      stripe
                                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                                <el-table-column prop="server_name" label='战区名' width="160" fixed></el-table-column>
                                <el-table-column label='战区从属' width="160" fixed>
                                    <template slot-scope="scope">
                                        {{scope.row.pattern}}
                                        ( <span  v-for="item in serverPattern" :key="item.id" v-if="item.id===scope.row.pattern">{{item.lang}}</span>)
                                        <el-tooltip class="item" effect="dark" placement="top-start">
                                            <div slot="content">
                                                战区从属描述：<br/>
                                                0-"未设置战区"<br/>
                                                1-"官方战区"<br/>
                                                2-"渠道战区"<br/>
                                                3-"海外互通战区"<br/>
                                                cjhwy2-"内部战区"<br/>
                                            </div>
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="server_number" label='编号' width="100"></el-table-column>
                                <el-table-column prop="server_order" label='序号' width="100"></el-table-column>
                                <el-table-column prop="combine_server_number" label='主服编号' width="100"></el-table-column>
                                <el-table-column prop="server_url" label='外网访问地址' width="350"></el-table-column>
                                <el-table-column prop="inner_urls" label='内部负载地址' width="350"></el-table-column>
                                <el-table-column label='操作处理' width="300" >
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="worldModifyShow(scope.row)">
                                            信息修改
                                        </el-button>
                                        <el-button type="text" @click="worldMaintenanceShow(scope.row)">
                                            维护
                                        </el-button>
                                        <el-button type="text" @click="worldGatewayReloadConnect(scope.row)">
                                            网关链接重置
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>

                        <el-dialog
                                :title="'<' + modifyWorldForm.serverName + '>战区信息调整'"
                            :visible.sync="modifyWorldShowTag"
                            width="35%" lock-scroll
                            center>
                            <el-form label-width="30%" label-suffix=":" label-position="right">
                                <el-form-item label="战区名">
                                    <el-input v-model="modifyWorldForm.serverName"></el-input>
                                </el-form-item>
                                <el-form-item label="排序">
                                    <el-input-number v-model="modifyWorldForm.serverOrder"></el-input-number>
                                    <div class="sort-tip">(注意:且数字越大的排在越前面)</div>
                                </el-form-item>
                                <el-form-item label="战区从属">
                                    <el-select v-model="modifyWorldForm.pattern">
                                        <el-option :key="index"
                                                   v-for="(serverPatternItem,index) in serverPatternOption"
                                                   :label="serverPatternItem.id + '(' + serverPatternItem.lang + ')'"
                                                   :value="serverPatternItem.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>

                            <div slot="footer" class="dialog-footer">
                                <el-button @click="worldModifyClose">取消</el-button>
                                <el-button type="primary" @click="worldModifyConfirm">确认</el-button>
                            </div>
                        </el-dialog>

                        <el-dialog
                                :title="'<' + worldMaintenanceForm.serverName + '>战区维护信息设置'"
                                :visible.sync="worldMaintenanceShowTag"
                                width="35%" lock-scroll
                                center
                        >
                            <el-form label-width="160px" label-suffix=":" label-position="right">
                                <el-form-item label="是否无限期维护">
                                    <el-switch v-model="worldMaintenanceForm.safeguardTag" active-text="是" inactive-text="否"></el-switch>
                                </el-form-item>
                                <el-form-item label="时区" v-if="!worldMaintenanceForm.safeguardTag">
                                    <el-select v-model="localZoneTime">
                                        <el-option
                                            v-for="localZoneTimeItem in localZoneTimeOptions"
                                            :key="localZoneTimeItem.value"
                                            :value="localZoneTimeItem.value"
                                            :label="localZoneTimeItem.label">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="维护结束时间" v-if="!worldMaintenanceForm.safeguardTag">
                                    <el-date-picker v-model="localSafeguardDate" @change="getSafeguardDate()" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="本地维护结束时间" v-if="!worldMaintenanceForm.safeguardTag && localSafeguardDate">
                                    <span class="sort-tip">{{localSafeguardDate2}}(utc{{localZoneTime}})</span>
                                </el-form-item>
                                <el-form-item label="服务器维护结束时间" v-if="!worldMaintenanceForm.safeguardTag && localSafeguardDate">
                                    <span class="sort-tip">{{worldMaintenanceForm.safeguardDate}}(utc{{serverZoneTime}})</span>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="worldMaintenanceShowTag = false">取消</el-button>
                                <el-button type="primary" @click="worldMaintenanceConfirm">确认</el-button>
                            </div>
                        </el-dialog>
                    </el-tab-pane>

                    <el-tab-pane label="游戏服" name="login_info_game">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>机器信息</span>
                            </div>

                            <el-table :data="loginInfoGame"
                                      row-key="id"
                                      border
                                      stripe
                                      style="width: 100%;"
                                      :default-sort="{prop: 'id'}"
                                      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                                      default-expand-all
                            >
                                <el-table-column prop="server_number" label='编号' width="100" sortable></el-table-column>
                                <el-table-column prop="server_name" label='服务器名' width="160" fixed></el-table-column>
                                <el-table-column prop="world_id" label='所属战区ID' width="150"></el-table-column>
                                <el-table-column prop="server_order" label='序号' width="100"></el-table-column>
                                <el-table-column prop="new_flag" label='新服标识' width="100"></el-table-column>
                                <el-table-column prop="server_pic" label='图标' width="100"></el-table-column>
                                <el-table-column prop="max_online" label='最大在线数' width="100"></el-table-column>
                                <el-table-column prop="max_register" label='最大注册数' width="100"></el-table-column>
                                <el-table-column prop="server_load" label='状态信息' width="140" sortable>
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.server_maintenance !== -1">
                                            <span  v-for="item in serverLoad" :key="item.id" v-if="scope.row.server_maintenance === item.id">{{item.lang}}</span>
                                        </template>
                                        <template v-if="scope.row.server_maintenance === -1">
                                            <span  v-for="item in serverLoad" :key="item.id" v-if="scope.row.server_load === item.id">{{item.lang}}</span>
                                        </template>
                                        <el-tooltip class="item" effect="dark" placement="top-start">
                                            <div slot="content">
                                                状态信息描述：<br/>
                                                0-"维护（普通玩家可见不可进，白名单可见可进"<br/>
                                                1-"畅通"<br/>
                                                2-"火爆"<br/>
                                                3-"爆满（老玩家可进）"<br/>
                                                4-"调试状态（普通玩家不可见，白名单可看见可进）"<br/>
                                                5-"无限期维护（普通玩家可见不可进，白名单可见可进）"<br/>
                                                6-"预备状态（准备好开服，普通玩家不可见，白名单可见可进）"<br/>
                                            </div>
                                            <i class="el-icon-question"></i>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column label='维护结束时间' width="200" >
                                    <template slot-scope="scope">
                                        <template v-if="scope.row.server_maintenance !== -1">
                                            <span>{{transferToTime(scope.row.server_maintenance_time) }}</span>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="server_url" label='外网访问地址' width="350"></el-table-column>
                                <el-table-column prop="socket_url" label='网关访问地址' width="350"></el-table-column>
                                <el-table-column prop="inner_urls" label='内部负载地址' width="350"></el-table-column>
                                <el-table-column label='内部负载地址' width="300">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="gameModifyShow(scope.row)">信息修改</el-button>
                                        <el-button type="text" @click="queueShow(scope.row)">排队信息</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-dialog
                                :title="'<' + modifyGameForm.serverName + '>游戏服信息调整'"
                                :visible.sync="modifyGameShowTag"
                                width="50%" lock-scroll
                                center
                            >
                                <el-form label-width="30%" label-suffix=":" label-position="right">
                                    <el-form-item label="游戏服名">
                                        <el-input v-model="modifyGameForm.serverName"></el-input>
                                    </el-form-item>
                                    <el-form-item label="状态标识">
                                        <el-select v-model="modifyGameForm.serverLoad">
                                            <el-option :key="index"
                                                       v-for="(serverLoadItem,index) in serverLoadOption"
                                                       :label="serverLoadItem.id + '(' + serverLoadItem.lang + ')'"
                                                       :value="serverLoadItem.id"
                                                       :disabled="(modifyGameForm.serverLoad !== 4 &&serverLoadItem.id === 6)"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="新服标识">
                                        <el-input-number v-model="modifyGameForm.newFlag"></el-input-number>
                                        <div class="sort-tip">(注意:0不展示新服标识,大于0展示新服标识且数字越大越靠前)</div>
                                    </el-form-item>
                                    <el-form-item label="排序">
                                        <el-input-number v-model="modifyGameForm.serverOrder"></el-input-number>
                                        <div class="sort-tip">(注意:有新服标识且数字越大的排在越前面)</div>
                                    </el-form-item>
                                    <el-form-item label="图标" >
                                        <el-input v-model="modifyGameForm.serverPic"></el-input>
                                    </el-form-item>
                                    <el-form-item label="最大注册数" >
                                        <el-input v-model="modifyGameForm.maxRegister"></el-input>
                                    </el-form-item>
                                    <el-form-item label="最大在线数" >
                                        <el-input v-model="modifyGameForm.maxOnline"></el-input>
                                    </el-form-item>
                                    <el-form-item label="时区" v-if="modifyGameForm.serverLoad == 6">
                                        <el-select v-model="localZoneTime2">
                                            <el-option
                                                v-for="localZoneTimeItem in localZoneTimeOptions"
                                                :key="localZoneTimeItem.value"
                                                :value="localZoneTimeItem.value"
                                                :label="localZoneTimeItem.label">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="定时开服" v-if="modifyGameForm.serverLoad == 6">
                                        <el-date-picker v-model="localOpenTime" @change="getOpenTime()" type="datetime" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="本地定时开服" v-if="modifyGameForm.serverLoad == 6">
                                        <span class="sort-tip">{{localOpenTime2}}(utc{{localZoneTime2}})</span>
                                    </el-form-item>
                                    <el-form-item label="服务器定时开服" v-if="modifyGameForm.serverLoad == 6">
                                        <span class="sort-tip">{{modifyGameForm.openTime}}(utc{{serverZoneTime}})</span>
                                    </el-form-item>
                                </el-form>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="gameModifyClose">取消</el-button>
                                    <el-button type="primary" @click="gameModifyConfirm">确认</el-button>
                                </div>
                            </el-dialog>

                            <el-dialog
                                :title="'<'+queueInfoForm.serverName + '>排队信息:'"
                                :visible.sync="queueShowTag"
                                width="35%" lock-scroll
                                center
                            >
                                <el-form label-width="30%" label-suffix=":" label-position="right">
                                    <el-form-item label="">
                                        <el-button @click="queueRefresh()" type="primary">查询队伍信息</el-button>
                                        <div class="sort-tip">当前队伍人数为:{{queueInfoForm.resultQueue}}</div>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-button @click="queueClear()" type="primary">清理队伍信息</el-button>
                                        <div class="sort-tip">响应结果:{{queueInfoForm.result}}</div>
                                    </el-form-item>
                                </el-form>
                            </el-dialog>
                        </el-card>
                    </el-tab-pane>

                </el-tabs>
            </el-card>
        </section>
    </div>

</template>

<script>
import {apis} from '../../lib/apis'
import FileSaver from 'file-saver'
import commonApi from '../../service/common_api'
import confApi from '../../service/conf_api'
import machineApi from '../../service/machine_api'
import worldApi from '../../service/world_api'
import gameApi from '../../service/game_api'
import loginApi from '../../service/login_api'
import beastsApi from '../../service/beasts_api'
import actionConfirm from '../../mixins/action_confirm'
import server_load from '../../data/config/server_load.json';
import server_load_option from '../../data/config/server_load_option.json';
import server_pattern from '../../data/config/server_pattern.json';
import server_pattern_option from '../../data/config/server_pattern_option.json';
import {mapState} from 'vuex';
import {off} from "element-ui";
import Utils from '../../lib/utils';

export default {
    data() {
        return {
            utils: Utils,
            title: this.$route.meta.title,
            serverZoneTime: Global_Config_Yunwei.serverZoneTime,
            serverLoad:server_load,
            serverLoadOption:server_load_option,
            serverPattern:server_pattern,
            serverPatternOption:server_pattern_option,
            activeName:"login_info_game",
            yunweiLoginList:[],
            yunweiNodeList:[],
            resultShow:false,
            resultArray:[],
            loginInfoGame:[],

            modifyGameShowTag:false,
            modifyGameForm:{},
            localOpenTime: '',
            localOpenTime2: '',

            queueShowTag: false,
            queueInfoForm:{},

            loginInfoWorld:[],
            modifyWorldShowTag:false,
            modifyWorldForm:{},

            worldMaintenanceShowTag:false,
            worldMaintenanceForm:{},
            localSafeguardDate: '',
            localSafeguardDate2: '',

            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            localZoneTime: 8,
            localZoneTime2: 8,
            localZoneTimeOptions: [
                {
                    label: 'utc8',
                    value: 8
                },
                {
                    label: 'utc-5',
                    value: -5
                }
            ],
        }
    },
    mixins: [actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken
        }),
    },
    mounted() {
    },
    created() {
        this.getLangs();
        this.grabLoginInfoData(this.activeName);
        this.grabYunweiLoginInfo();

    },
    methods: {
        getSafeguardDate() {
            let self = this;
            const date = new Date(self.localSafeguardDate);
            let localTime = '';
            let localTimeZone = self.localZoneTime;

            localTime = date;
            self.localSafeguardDate2 = Utils.formatDate(localTime);

            let time = '';
            let timeZone = self.serverZoneTime;

            if (localTimeZone == -5) {
                if (timeZone == -5) {
                    time = localTime;
                } else if (timeZone == 8) {
                    time = self.west5TimeToEast8Time(date)
                }
            } else if (localTimeZone == 8) {
                if (timeZone == -5) {
                    time = self.toWest5Time(date)
                } else if (timeZone == 8) {
                    time = localTime;
                }
            }

            self.worldMaintenanceForm.safeguardDate = Utils.formatDate(time);
        },

        getOpenTime() {
            let self = this;
            const date = new Date(self.localOpenTime);
            let localTime = '';
            let localTimeZone = self.localZoneTime2;

            localTime = date;
            self.localOpenTime2 = Utils.formatDate(localTime);

            let time = '';
            let timeZone = self.serverZoneTime;

            if (localTimeZone == -5) {
                if (timeZone == -5) {
                    time = localTime;
                } else if (timeZone == 8) {
                    time = self.west5TimeToEast8Time(date)
                }
            } else if (localTimeZone == 8) {
                if (timeZone == -5) {
                    time = self.toWest5Time(date)
                } else if (timeZone == 8) {
                    time = localTime;
                }
            }

            self.modifyGameForm.openTime = Utils.formatDate(time);
        },

        transferToTime(timestamp){
            let time = new Date(timestamp);
            return time.toLocaleString('zh-CN',{timezone : 'Asia/Shanghai'});
        },
        handleClick(tab, event) {
            this.grabLoginInfoData(this.activeName);
        },
        // 获取登录服和战斗服数据
        grabYunweiLoginInfo() {
            let self = this;
            confApi.getReadData({
                token: self.token,
                tableName: 'yunwei_server_config'
            }).then(res => {
                self.yunweiLoginList = [];
                self.yunweiNodeList = [];
                res.forEach(item => {
                    if (item.server_type == 'login') {
                        self.yunweiLoginList.push(item);
                    }else if (item.server_type == 'battleValidate') {
                        self.yunweiNodeList.push(item);
                    }
                })
            })
        },
        grabLoginInfoData(tableName){
            commonApi.getConfs({
                tables: tableName
            }).then(res => {
                if (tableName === 'login_info_game') {
                    let sourceGameInfo = res[tableName];
                    this.loginInfoGame = [];
                    let subInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }
                }
                else if (tableName === 'login_info_world') {
                    let sourceWorldInfo = res[tableName];
                    this.loginInfoWorld = [];
                    let subInfo = [];
                    for (let tmpItem of sourceWorldInfo) {
                        tmpItem.server_maintenance = -1;
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoWorld.push(tmpItem);
                        } else {
                            subInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subInfo) {
                        this.loginInfoWorld.forEach(mainServer => {
                            if (tmpItem.combine_server_number === mainServer.server_number) {
                                mainServer.children.push(tmpItem);
                            }
                        })
                    }
                }
            })
        },
        /**
         * 显示修改信息表单
         * @param row
         */
        gameModifyShow(row) {
            let self = this;
            self.modifyGameShowTag = true;
            let openTime = ''
            if (row.open_time == -1) {
                openTime = ''
            } else {
                openTime = self.utils.formatDate(row.open_time);
            }

            self.modifyGameForm = {
                id: row.id,
                serverName: row.server_name,
                serverLoad: row.server_load,
                serverOrder: row.server_order,
                serverPic: row.server_pic,
                newFlag: row.new_flag,
                maxOnline: row.max_online,
                maxRegister: row.max_register,
                rowData:row,
                openTime: openTime
            }
        },
        gameModifyClose(row) {
            let self = this;
            self.modifyGameShowTag = false;
            self.modifyGameForm = {}
        },
        gameModifyConfirm(){
            let self = this;
            let sourceRowDataMaxOnline = self.modifyGameForm.rowData.max_online;
            let sourceRowDataMaxRegister = self.modifyGameForm.rowData.max_register;
            if (self.modifyGameForm.maxOnline > sourceRowDataMaxOnline){
                this.$message({
                    type: 'danger',
                    message: '数值无法上调：最大在线数'
                })
                return;
            }

            if (self.modifyGameForm.maxRegister > sourceRowDataMaxRegister){
                this.$message({
                    type: 'danger',
                    message: '数值无法上调：最大注册数'
                })
                return;
            }

            this.$confirm("此操作会重载登录服和对应的游戏服（玩家无感）", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                machineApi.changeGameMachineInfo({
                    token: self.token,
                    beastsMachineChangeBO: self.modifyGameForm
                }).then(res =>{
                    self.modifyGameShowTag = false;
                    let reloadGameInfo = self.modifyGameForm.rowData;
                    self.resultArray = [];
                    self.resultShow = true;
                    this.$message({
                        type: 'success',
                        message: ' 发送重载中，请等待！'
                    })
                    self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                        self.resultArray.push({
                            serverUrl: yunweiLoginInfo.server_url,
                            serverNumber:'',
                            serverName: yunweiLoginInfo.server_name,
                            resStatus: '0',
                            resMsg:'未发送',
                            type:'login'
                        });
                    })

                    let balanceIps = reloadGameInfo.inner_urls.split(';');
                    balanceIps.forEach(item => {
                        if ('' != item) {
                            self.resultArray.push({
                                serverUrl: item,
                                serverNumber:reloadGameInfo.server_number,
                                serverName: reloadGameInfo.server_name,
                                resStatus: '0',
                                resMsg:'未发送',
                                type:'game'
                            });
                        }
                    })

                    beastsApi.reloadClzName({
                        token: this.token,
                        reloadForm: {
                            reloadTypes: ['login', 'game'],
                            gameNumbers: [reloadGameInfo.server_number],
                            worldNumbers: [],
                            reloadMode: '1',
                            clzName: 'LoginInfoGameConfig'
                        }
                    }).then(res => {
                        /*self.resultArray = [];
                        res.forEach((item) => {
                            self.resultArray.push(item);
                        })*/
                        res.forEach((item) => {
                            self.resultArray.forEach(item2=>{
                                if (item2.serverUrl === item.serverUrl){
                                    item2.resStatus = item.resStatus;
                                    item2.resMsg = item.resMsg;
                                }
                            })
                        })
                        this.$message({
                            type: 'success',
                            message: ' 操作重载完毕！'
                        })
                    })

                    //self.reloadAxiosGame(self.modifyGameForm.rowData);
                    self.grabLoginInfoData('login_info_game');
                })
            })
        },

        queueShow(row){
            this.queueShowTag = true;
            this.queueInfoForm = {
                serverName:row.server_name,
                result:'',
                resultQueue:'',
                rowData:row
            };
        },
        queueRefresh(){
            let self = this;
            let innerUrls = self.queueInfoForm.rowData.inner_urls;
            gameApi.loginQueueOperation(
                {
                    token:self.token,
                    operationForm:{
                        uri:innerUrls.split(";")[0],
                        op:"1"
                    }
                }
            ).then(res =>{
                let result = "查询失败";
                let resultJson = JSON.parse(res.contentSource);
                if (resultJson.code == 0){
                    let count = 0;
                    if (resultJson.data != ''){
                        count = resultJson.data;
                    }
                    result = count;
                }
                self.queueInfoForm.resultQueue = result;
            })
        },
        queueClear(){
            let self = this;
            let innerUrls = self.queueInfoForm.rowData.inner_urls;
            gameApi.loginQueueOperation(
                {
                    token:self.token,
                    operationForm:{
                        uri:innerUrls.split(";")[0],
                        op:"2"
                    }
                }
            ).then(res =>{
                let result = "清理失败";
                let resultJson = JSON.parse(res.contentSource);
                if (resultJson.code == 0){
                    result = '清理成功';
                }
                self.queueInfoForm.result = result;
            })
        },

        // 重载游戏服
        reloadAxiosGame(reloadGameInfo) {
            let self = this;
            self.resultShow = true;
            self.resultArray = [];

            self.reloadAxioxLogin();

            if (reloadGameInfo !== undefined) {
                self.reloadGameItem(reloadGameInfo);
            }
        },

        /**
         * 重载单个游戏服
         * @param reloadGameInfo
         */
        reloadGameItem(reloadGameInfo){
            let self = this;
            let balanceIps = reloadGameInfo.inner_urls.split(';');
            balanceIps.forEach(item => {
                if ('' != item) {
                    self.resultArray.push({
                        server_url: item,
                        server_name: reloadGameInfo.server_name,
                        resStatus: '0'
                    });
                    let reloadForm = {
                        uri: item,
                        type: 'game',
                        className: 'LoginInfoGameConfig',
                        serverName: reloadGameInfo.server_name
                    }
                    gameApi.gameReloadConfig({
                        token: self.token,
                        reloadForm: reloadForm
                    }).then(res => {
                        self.resultArray.forEach(resultItem => {
                            if (resultItem.server_url == reloadForm.uri) {
                                resultItem.resStatus = res.resStatus
                            }
                        })
                    })
                }
            })
        },

        /**
         * 重载单个战区
         * @param reloadWorldInfo
         */
        reloadWorldItem(reloadWorldInfo){
            let self = this;
            let balanceIps = reloadWorldInfo.inner_urls.split(';');

            balanceIps.forEach(item => {
                if ('' != item) {
                    self.resultArray.push({
                        server_url: item,
                        server_name: reloadWorldInfo.server_name,
                        resStatus: '0'
                    });

                    let reloadForm = {
                        worldUri: item,
                        type: 'world',
                        className: 'LoginInfoGameConfig',
                        serverName: reloadWorldInfo.server_name
                    }
                    worldApi.worldReloadConfig({
                        token: self.token,
                        reloadForm: reloadForm
                    }).then(res => {
                        self.resultArray.forEach(resultItem => {
                            if (resultItem.server_url == reloadForm.worldUri) {
                                resultItem.resStatus = res.resStatus
                            }
                        })
                    })
                }
            })
        },

        /**
         * 登录服重载
         */
        reloadAxioxLogin(){
            let self = this;
            self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                self.resultArray.push({
                    server_url: yunweiLoginInfo.server_url,
                    server_name: yunweiLoginInfo.server_name,
                    resStatus: '0'
                });
                let reloadForm =
                    {
                        loginUri: yunweiLoginInfo.server_url,
                        type: yunweiLoginInfo.type,
                        className: 'LoginInfoGameConfig',
                        serverName: yunweiLoginInfo.server_name
                    };

                loginApi.loginReloadConfig({
                    token: self.token,
                    reloadForm: reloadForm
                }).then(res => {
                    self.resultArray.forEach(resultItem => {
                        if (resultItem.server_url == reloadForm.loginUri) {
                            resultItem.resStatus = res.resStatus
                        }
                    })
                    console.log("登录服信息列表重载成功")
                })
            })
        },

        /**
         * 战区重载
         * @param reloadWorldInfo
         */
        reloadAxioxWorld(reloadWorldInfo){
            let self = this;
            self.resultShow = true;
            self.resultArray = [];
            self.reloadAxioxLogin();
            if (reloadWorldInfo !== undefined) {
                self.grabLoginInfoData("login_info_game");
                let worldId = reloadWorldInfo.id;
                self.loginInfoGame.forEach(loginInfoGameItem=>{
                    if (worldId == loginInfoGameItem.world_id){
                        self.reloadGameItem(loginInfoGameItem);
                    }
                    for (const subWorldInfo of reloadWorldInfo.children) {
                        if (subWorldInfo.id == loginInfoGameItem.world_id){
                            self.reloadGameItem(loginInfoGameItem);
                        }
                    }
                })
                self.reloadWorldItem(reloadWorldInfo);
            }
        },
        worldModifyShow(row) {
            let self = this;
            self.modifyWorldShowTag = true;
            self.modifyWorldForm = {
                id: row.id,
                serverName: row.server_name,
                serverOrder: row.server_order,
                pattern: row.pattern,
                rowData:row,
            }
        },
        worldModifyClose(row) {
            let self = this;
            self.modifyWorldShowTag = false;
            self.modifyWorldForm = {}
        },

        worldModifyConfirm(){
            let self = this;
            this.$confirm("此操作会重载登录服（玩家无感）", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                machineApi.changeWorldMachineInfo({
                    token: self.token,
                    beastsMachineChangeBO: self.modifyWorldForm
                }).then(res =>{
                    self.modifyGameShowTag = false;
                    self.resultShow = true;
                    self.resultArray = [];
                    //self.reloadAxioxLogin();

                    self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                        self.resultArray.push({
                            serverUrl: yunweiLoginInfo.server_url,
                            serverNumber:'',
                            serverName: yunweiLoginInfo.server_name,
                            resStatus: '0',
                            resMsg:'未发送',
                            type:'login'
                        });
                    })

                    beastsApi.reloadClzName({
                        token: this.token,
                        reloadForm: {
                            reloadTypes: ['login'],
                            gameNumbers: [],
                            worldNumbers: [],
                            reloadMode: '1',
                            clzName: 'LoginInfoGameConfig'
                        }
                    }).then(res => {

                        res.forEach((item) => {
                            self.resultArray.forEach(item2=>{
                                if (item2.serverUrl === item.serverUrl){
                                    item2.resStatus = item.resStatus;
                                    item2.resMsg = item.resMsg;
                                }
                            })
                        })
                        this.$message({
                            type: 'success',
                            message: ' 操作重载完毕！'
                        })
                    })

                    self.grabLoginInfoData('login_info_world');
                })
            })
        },


        /**
         * 重载网关链接
         * @param row
         */
        worldGatewayReloadConnect(row) {
            let self = this;
            let worldUriArr = row.inner_urls.split(';');
            this.$confirm('此操作会向<'+row.server_name+'>归属的所有游戏服gateway发消息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                worldUriArr.forEach(item => {
                    if (item == ''){
                        return;
                    }
                    worldApi.reloadConnect({
                        token: self.token,
                        reloadForm: {
                            worldUri: item
                        }
                    }).then(res => {
                        self.$message({
                            type: 'success',
                            message: item + '重载成功!'
                        })
                    })
                })
            });
        },

        /**
         * 维护
         * @param row
         */
        worldMaintenanceShow(row){
            let self = this;
            self.worldMaintenanceShowTag = true;
            if (row){
                self.worldMaintenanceForm = {
                    id:row.id,
                    serverName:row.server_name,
                    safeguardTag:false,
                    safeguardDate:'',
                    rowData:row
                }
            }else{
                self.worldMaintenanceForm = {
                    id:-1,
                    serverName:'全部战区',
                    safeguardTag:false,
                    safeguardDate:'',
                }
            }

        },

        /**
         * 战区维护
         */
        worldMaintenanceConfirm(){
            let self = this;
            if (!self.worldMaintenanceForm.safeguardTag) {
                let localDateTime = new Date().getTime();
                let endDate =new Date(self.safeguardDate).getTime();
                if (localDateTime > endDate ) {
                    this.$message({
                        type: 'warning',
                        message: '时间不正确'
                    });
                    return;
                }
            } else {
                self.worldMaintenanceForm.safeguardDate = '';
            }

            this.$confirm("此操作会向<"+self.worldMaintenanceForm.serverName+">归属的所有游戏服,战区以及全部登录服 进行重载（玩家会被踢下线）", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                machineApi.worldMaintenance({
                    token: self.token,
                    worldMaintenanceForm: {
                        worldId: self.worldMaintenanceForm.id,
                        endDate: self.worldMaintenanceForm.safeguardDate,
                        indefiniteTime: self.worldMaintenanceForm.safeguardTag
                    }
                }).then(res =>{
                    self.modifyGameShowTag = false;
                    self.resultShow = true;
                    self.resultArray = [];


                    self.yunweiLoginList.forEach((yunweiLoginInfo) => {
                        self.resultArray.push({
                            serverUrl: yunweiLoginInfo.server_url,
                            serverNumber:'',
                            serverName: yunweiLoginInfo.server_name,
                            resStatus: '0',
                            resMsg:'未发送',
                            type:'login'
                        });
                    })
                    let reloadTypes = [];
                    reloadTypes.push('login');

                    let gameNumbers = [];
                    let worldNumbers = [];
                    let reloadGameType = 'game';
                    let reloadWorldType = 'world';
                    self.grabLoginInfoData("login_info_game");

                    if (self.worldMaintenanceForm.id == -1){
                        reloadGameType = 'wholeGame';
                        reloadWorldType = 'wholeWorld';

                        self.loginInfoWorld.forEach(worldItem =>{
                            let reloadWorldInfo = worldItem;

                            if (reloadWorldInfo !== undefined) {

                                let worldId = reloadWorldInfo.id;
                                self.loginInfoGame.forEach(reloadGameInfo=>{
                                    if (worldId == reloadGameInfo.world_id){
                                        gameNumbers.push(reloadGameInfo.server_number);

                                        let balanceIps = reloadGameInfo.inner_urls.split(';');
                                        balanceIps.forEach(item => {
                                            if ('' != item) {
                                                self.resultArray.push({
                                                    serverUrl: item,
                                                    serverNumber:reloadGameInfo.server_number,
                                                    serverName: reloadGameInfo.server_name,
                                                    resStatus: '0',
                                                    resMsg:'未发送',
                                                    type:'game'
                                                });
                                            }
                                        })
                                        //self.reloadGameItem(loginInfoGameItem);
                                    }
                                    for (const subWorldInfo of reloadWorldInfo.children) {
                                        if (subWorldInfo.id == reloadGameInfo.world_id){
                                            gameNumbers.push(reloadGameInfo.server_number);

                                            let balanceIps = reloadGameInfo.inner_urls.split(';');
                                            balanceIps.forEach(item => {
                                                if ('' != item) {
                                                    self.resultArray.push({
                                                        serverUrl: item,
                                                        serverNumber:reloadGameInfo.server_number,
                                                        serverName: reloadGameInfo.server_name,
                                                        resStatus: '0',
                                                        resMsg:'未发送',
                                                        type:'game'
                                                    });
                                                }
                                            })
                                            //self.reloadGameItem(loginInfoGameItem);
                                        }
                                    }
                                })

                                worldNumbers.push(reloadWorldInfo.server_number);
                                let balanceIps = reloadWorldInfo.inner_urls.split(';');
                                balanceIps.forEach(item => {
                                    if ('' != item) {
                                        self.resultArray.push({
                                            serverUrl: item,
                                            serverNumber:reloadWorldInfo.server_number,
                                            serverName: reloadWorldInfo.server_name,
                                            resStatus: '0',
                                            resMsg:'未发送',
                                            type:'world'
                                        });
                                    }
                                })

                                //self.reloadWorldItem(reloadWorldInfo);
                            }
                        })

                        /*
                        self.loginInfoWorld.forEach(worldItem =>{
                            self.reloadAxioxWorld(worldItem);
                        })
                        */
                    }
                    else{
                        //self.reloadAxioxWorld(self.worldMaintenanceForm.rowData);
                        let reloadWorldInfo = self.worldMaintenanceForm.rowData;

                        if (reloadWorldInfo !== undefined) {

                            let worldId = reloadWorldInfo.id;
                            self.loginInfoGame.forEach(reloadGameInfo=>{
                                if (worldId == reloadGameInfo.world_id){
                                    gameNumbers.push(reloadGameInfo.server_number);

                                    let balanceIps = reloadGameInfo.inner_urls.split(';');
                                    balanceIps.forEach(item => {
                                        if ('' != item) {
                                            self.resultArray.push({
                                                serverUrl: item,
                                                serverNumber:reloadGameInfo.server_number,
                                                serverName: reloadGameInfo.server_name,
                                                resStatus: '0',
                                                resMsg:'未发送',
                                                type:'game'
                                            });
                                        }
                                    })
                                    //self.reloadGameItem(loginInfoGameItem);
                                }
                                for (const subWorldInfo of reloadWorldInfo.children) {
                                    if (subWorldInfo.id == reloadGameInfo.world_id){
                                        gameNumbers.push(reloadGameInfo.server_number);

                                        let balanceIps = reloadGameInfo.inner_urls.split(';');
                                        balanceIps.forEach(item => {
                                            if ('' != item) {
                                                self.resultArray.push({
                                                    serverUrl: item,
                                                    serverNumber:reloadGameInfo.server_number,
                                                    serverName: reloadGameInfo.server_name,
                                                    resStatus: '0',
                                                    resMsg:'未发送',
                                                    type:'game'
                                                });
                                            }
                                        })
                                        //self.reloadGameItem(loginInfoGameItem);
                                    }
                                }
                            })

                            worldNumbers.push(reloadWorldInfo.server_number);
                            let balanceIps = reloadWorldInfo.inner_urls.split(';');
                            balanceIps.forEach(item => {
                                if ('' != item) {
                                    self.resultArray.push({
                                        serverUrl: item,
                                        serverNumber:reloadWorldInfo.server_number,
                                        serverName: reloadWorldInfo.server_name,
                                        resStatus: '0',
                                        resMsg:'未发送',
                                        type:'world'
                                    });
                                }
                            })

                            //self.reloadWorldItem(reloadWorldInfo);
                        }
                    }

                    reloadTypes.push(reloadGameType);
                    reloadTypes.push(reloadWorldType);

                    beastsApi.reloadClzName({
                        token: this.token,
                        reloadForm: {
                            reloadTypes: reloadTypes,
                            gameNumbers: gameNumbers,
                            worldNumbers: worldNumbers,
                            reloadMode: '1',
                            clzName: 'LoginInfoGameConfig'
                        }
                    }).then(res => {

                        res.forEach((item) => {
                            self.resultArray.forEach(item2=>{
                                if (item2.serverUrl === item.serverUrl){
                                    item2.resStatus = item.resStatus;
                                    item2.resMsg = item.resMsg;
                                }
                            })
                        })
                        this.$message({
                            type: 'success',
                            message: ' 操作重载完毕！'
                        })
                    })

                    self.grabLoginInfoData('login_info_world');
                    self.grabLoginInfoData('login_info_game');
                })
            })
        }
    }
};
</script>
<style lang="less">
.el-table__row .el-table__row--level-1 {
    background-color: #999999 !important;
}

.el-table:not(.el-table–scrollable-x) .el-table__fixed{
    height: 100% !important;
}

.server-row .el-input {
    margin-bottom: 10px;
}

.combine-tip {
    color: red;
    margin-bottom: 10px;
}

.upload-server {
    margin-left: 10px;
}

.sort-tip {
    color: red;
}

.white-list {
    width: 100px;
}

.volley-tip {
    color: red;
}

.login-btn-group {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/dev_tools/beasts_info.vue